"use client";

import { useState } from "react";
import { useMotionValueEvent, useScroll, motion } from "framer-motion";

import { Button } from "@/components/ui/button";
import Arrow from "@/components/icons/Arrow";

const BackToTop = ({ variant = "default" }: any) => {
  const [show, setShow] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    if (latest > 100) {
      setShow(true);
    } else {
      setShow(false);
    }
  });

  return (
    <motion.div initial={false} animate={{ opacity: show ? 1 : 0, pointerEvents: show ? "auto" : "none" }} className="fixed bottom-2.5 right-2.5 z-[120]">
      <Button onClick={() => scrollToTop()} variant={variant} size="round" fullWidth aria-label="Scroll naar top">
        <Arrow direction="up" color="white" />
      </Button>
    </motion.div>
  );
};

export default BackToTop;
